import { v4 as uuidv4 } from 'uuid';

const SESSION_STORAGE_KEY_GUEST_ID = 'GUEST_ID';

/**
 * ゲストIDを取得する
 * sessionStorageに保持されている場合はそれを返し、なければUUIDを生成して保持する
 *
 * @returns ゲストID
 */
export const getGuestId = (): string => {
  const storedId = sessionStorage.getItem(SESSION_STORAGE_KEY_GUEST_ID);
  if (storedId) {
    return storedId;
  }

  const newId = uuidv4();
  sessionStorage.setItem(SESSION_STORAGE_KEY_GUEST_ID, newId);

  return newId;
};
